import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenerateCvService } from 'src/app/services/generate-cv/generate-cv.service';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { CvDbService } from 'src/app/services/cv-db/cv-db.service';

@Component({
  selector: 'app-generate-cv-steps',
  templateUrl: './generate-cv-steps.component.html',
  styleUrls: ['./generate-cv-steps.component.css'],
})
export class GenerateCVStepsComponent {
  steps: MenuItem[] = [];
  activeIndex: number = 0;
  cvForm!: FormGroup;
  userInfo?: any = JSON.parse(localStorage.getItem('userInfo') || '{}');

  constructor(
    private translate: TranslateService,
    private fb: FormBuilder,
    private generateCvService: GenerateCvService,
    private paymentService: PaymentService,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private cvDbService: CvDbService
  ) {
    this.getTranslateSteps();
    this.translate.onLangChange.subscribe(() => {
      this.getTranslateSteps();
    });
  }

  ngOnInit() {
    this.cvForm = this.fb.group({
      name: ['', Validators.required],
      title: ['', Validators.required],
      city: ['', Validators.required],
      phone: ['', Validators.required],
      skill: this.fb.array([]),
      languages: this.fb.array([]),
      target: this.fb.array([]),
      course: this.fb.array([]),
      certification: this.fb.array([]),
      project: this.fb.array([]),
      education: this.fb.array([]),
      linkedIn: ['', Validators.required],
      country: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      summary: ['', Validators.required],
      experiences: this.fb.array([]),
      cvTempletePath: ['', Validators.required],
      cvTempleteFile: ['', Validators.required],
      coverLetterPath: ['', Validators.required],
    });
  }

  getTranslateSteps() {
    this.translate
      .get([
        'Target',
        'Template',
        'Select Resume',
        'Personal Data',
        'Work Experience',
        'Education',
        'Skills',
        'Review',
      ])
      .subscribe((translations) => {
        this.steps = [
          { label: translations['Target'] },
          { label: translations['Template'] },
          { label: translations['Select Resume'] },
          { label: translations['Personal Data'] },
          { label: translations['Work Experience'] },
          { label: translations['Education'] },
          { label: translations['Skills'] },
          { label: translations['Review'] },
        ];
      });
  }

  next() {
    setTimeout(() => {
      requestAnimationFrame(() => {
        const content = document.querySelector('#app');
        if (content) content.scrollTop = 0;
      });
    }, 50);
    if (this.activeIndex < this.steps.length - 1) {
      this.activeIndex++;
      console.log(this.cvForm.value);
    }
  }

 async DownloadResume() {
   
    await this.cvDbService.clearAllPdfs();

   

    this.generateCvService
      .sentCvJsonData(this.userInfo.userId, this.cvForm.value)
      .subscribe({
        next: (response: any) => {
          console.log(response);
          
            this.generateCvService.setData(response);
            this.router.navigateByUrl("/cv-review");
         },
        error: (err) => {
          console.log(err);
        },
      });
  }

  downloadFile(response: any, filename: string, type: string) {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const base64Data = response;
      const binaryData = this.base64ToArrayBuffer(base64Data);
      const blob = new Blob([binaryData], { type });
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);

      link.href = url;
      link.download = filename;
      link.click();

      window.URL.revokeObjectURL(url);
      this.sendGoogleEvent('download cv');
    }
  }

  private base64ToArrayBuffer(base64: string): ArrayBuffer {
    let binaryString = '';
    if (typeof window !== 'undefined') {
      binaryString = window.atob(base64);
    }

    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  previous(): any {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
    setTimeout(() => {
      requestAnimationFrame(() => {
        const content = document.querySelector('#app');
        if (content) content.scrollTop = 0;
      });
    }, 50);
  }
  sendGoogleEvent(name: string) {
    this.googleAnalyticsService.event(name);
    this.gtmService.pushTag({
      event: 'customEvent',
      category: 'button',
      action: 'click',
      label: name,
    });
  }
}
